// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { FeedItemRecord } = require('client-v2/common/containers/feed/records')
// Sibling imports
const FeaturedCarousel = require('./featured-carousel')
const FeaturedCollectionSlide = require('./featured-collection-slide')

const bem = BemEntity('FeaturedCollectionsCarousel')

function FeaturedCollectionsCarousel(props) {
  const { className, items, selfUserId, ...slideProps } = props
  const renderSlide = React.useCallback(
    item => (
      tag(FeaturedCollectionSlide, {
        ...slideProps,
        key: `FeaturedCollectionsCarouselSlide:${item.id}`,
        className: bem.element('slide'),
        collection: item.collection,
        isSelf: item.collection['user_id'] === selfUserId,
        pageContext: item.pageContext
      })
    ),
    [ selfUserId, ...Object.values(slideProps) ]
  )
  if (!items.length) {
    return null
  }
  return (
    tag(FeaturedCarousel, {
      className: classNames(
        className,
        bem.block()
      ),
      items,
      renderSlide
    })
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  FeaturedCollectionsCarousel.propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape(FeedItemRecord.propTypes)
    ).isRequired,
    selfUserId: PropTypes.number
  }
}

module.exports = FeaturedCollectionsCarousel
